module.exports = __webpack_public_path__ + "fwm_h5/img/logo_web_shulong.ee1a3661.png";